import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import { useAction } from 'hooks';
import Switch from 'components/Switch';
import App from 'modules/App';
import PatientResults from 'modules/PatientResults';
import AmbulatoryGlucoseProfile from 'modules/AmbulatoryGlucoseProfile';
import messages from '../../../../messages';
import ReportButton from './ReportButton';
const ActivePatientOptions = ()=>{
    const profileContext = useContext(ProfileContext);
    const activePatient = useSelector(profileContext.selectors.activePatient);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const phiSetDocumentId = useSelector(profileContext.selectors.phiSetDocumentId);
    // TODO: Refactor PatientResults usage
    const deviceMode = useSelector(PatientResults.selectors.deviceMode);
    const resultsIsInProgress = useSelector(PatientResults.selectors.resultsIsInProgress);
    const setReadings = useAction(profileContext.actions.setReadings);
    const setDeviceMode = useAction(PatientResults.actions.setDeviceMode);
    const storeSelectedReportTypes = useAction(PatientResults.actions.storeSelectedReportTypes);
    const prepareAgpPreview = useAction(AmbulatoryGlucoseProfile.actions.prepareAgpPreview);
    const goToReportsView = useAction(App.actions.goToReportsView);
    const { dataType } = activePatient || {};
    useEffect(()=>{
        if (dataType) setDeviceMode(dataType);
    }, [
        activePatient
    ]);
    useEffect(()=>{
        if (dataType === 'CGM' && phiSet) {
            prepareAgpPreview(activePatient, phiSet, phiSetDocumentId, setReadings);
        }
    }, [
        phiSet
    ]);
    if (!phiSet) {
        return null;
    }
    const onSetDeviceMode = ()=>{
        if (deviceMode === 'BGM') {
            prepareAgpPreview(activePatient, phiSet, phiSetDocumentId, setReadings);
        }
        setDeviceMode(deviceMode === 'AGP' ? dataType : 'AGP');
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Switch, {
                isDisabled: resultsIsInProgress,
                labelMessage: messages.sidebar.labels.agpView,
                isActive: deviceMode === 'AGP',
                onClick: onSetDeviceMode
            }),
            /*#__PURE__*/ _jsx(ReportButton, {
                storeSelectedReportTypes: storeSelectedReportTypes,
                goToReportsView: goToReportsView,
                isInProgress: resultsIsInProgress
            })
        ]
    });
};
export default ActivePatientOptions;
